import { render, staticRenderFns } from "./PurchasePaymentApproval.vue?vue&type=template&id=4f875045"
import script from "./PurchasePaymentApproval.vue?vue&type=script&lang=js"
export * from "./PurchasePaymentApproval.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports